/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import generatePagination from '../../utils/pagination';

import styles from './pagination.scss';

const paginate = (currentPage, lastPage, onClick, dataTestId) => {
    const range = generatePagination(currentPage, lastPage);

    return range.map((i, index) => {
        return (
            // eslint-disable-next-line no-restricted-globals
            !isNaN(i)
                ? (
                    <div
                        className={`${styles.paginationItem} ${currentPage === i ? 'active' : ''}`}
                        key={index}
                        onClick={() => !(currentPage === i) && onClick(i)}
                        data-testid={dataTestId && `${dataTestId}.page-${i}`}
                    >
                        {i}
                    </div>
                )
                : (
                    <div
                        className={`${styles.paginationItem} ${styles.ellipsis}`}
                        key={index}
                    >
                        &hellip;
                    </div>
                )
        );
    });
};

const Pagination = (props) => {
    const { currentPage, lastPage, onClick, 'data-testid': dataTestId } = props;
    let prevDisabled;
    let nextDisabled;

    if (currentPage === 1) {
        prevDisabled = true;
    }
    if (currentPage === lastPage) {
        nextDisabled = true;
    }

    return (
        <div className={styles.pagination} data-testid={dataTestId || undefined}>
            <div
                className={`${styles.paginationPrev} ${prevDisabled ? 'disabled' : ''}`}
                onClick={() => !prevDisabled && onClick(currentPage - 1)}
                data-testid={dataTestId && `${dataTestId}.prev-btn`}
            >
                <i className="fas fa-caret-left" /> Prev
            </div>
            {paginate(currentPage, lastPage || 1, onClick, dataTestId)}
            <div
                className={`${styles.paginationNext} ${nextDisabled ? 'disabled' : ''}`}
                onClick={() => !nextDisabled && onClick(currentPage + 1)}
                data-testid={dataTestId && `${dataTestId}.next-btn`}
            >
                Next <i className="fas fa-caret-right" />
            </div>
        </div>
    );
};

Pagination.propTypes = {
    currentPage: PropTypes.number,
    lastPage: PropTypes.number,
    onClick: PropTypes.func,
    'data-testid': PropTypes.string,
};

Pagination.defaultProps = {
    currentPage: 1,
    lastPage: 1,
    onClick: () => {},
    'data-testid': null,
};

export default Pagination;
